import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Ping from '../components/Ping.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/ping',
    name: 'About',
    component: Ping
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
